import { getMessageFromError } from '../utils/functions'

const PREFIX = 'admin/subscription-plan'
export default {
  /* -------------------------------------------------------------------------- */
  /*                               Create subscription plan                               */
  /* -------------------------------------------------------------------------- */
  async create({ commit }, data) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.post(`${PREFIX}/create`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      // Manage Error
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                List subscription plan                             */
  /* -------------------------------------------------------------------------- */
  async get({ commit }, params) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${PREFIX}/list`, { params })
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'records',
        data: res.data.data.results
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.data.totalResults
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.data.totalResults
      })
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  // /* -------------------------------------------------------------------------- */
  // /*                               Delete subscription plan                               */
  // /* -------------------------------------------------------------------------- */
  // async delete({ commit }, id) {
  //   commit('SET_STATE', {
  //     action: 'listLoading',
  //     data: true
  //   })
  //   try {
  //     const res = await this.$http.delete(`/${PREFIX}/delete/${id}`)
  //     commit('SET_STATE', {
  //       action: 'listLoading',
  //       data: false
  //     })
  //     return {
  //       data: res.data,
  //       message: res.data.message
  //     }
  //   } catch (error) {
  //     commit('SET_STATE', {
  //       action: 'listLoading',
  //       data: false
  //     })
  //     const { message } = getMessageFromError(error)
  //     return Promise.reject({
  //       message
  //     })
  //   }
  // },

  // /* -------------------------------------------------------------------------- */
  // /*                               Update subscription plan                               */
  // /* -------------------------------------------------------------------------- */
  // async update({ commit }, { id, data }) {
  //   commit('SET_STATE', {
  //     action: 'listLoading',
  //     data: true
  //   })
  //   try {
  //     const res = await this.$http.put(`${PREFIX}/update/${id}`, data)
  //     commit('SET_STATE', {
  //       action: 'listLoading',
  //       data: false
  //     })
  //     return {
  //       data: res.data.data,
  //       message: res.data.message
  //     }
  //   } catch (error) {
  //     commit('SET_STATE', {
  //       action: 'listLoading',
  //       data: false
  //     })
  //     const { message } = getMessageFromError(error)
  //     return Promise.reject({
  //       message
  //     })
  //   }
  // },

  /* -------------------------------------------------------------------------- */
  /*                               Show subscription plan                               */
  /* -------------------------------------------------------------------------- */
  async show({ commit }, id) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${PREFIX}/details/${id}`)
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'record',
        data: res.data.data
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  }
}
